// Journal Actions
import Axios from 'axios'
import * as helpers from '@/mixins/helperFunctions.js'

// ***** Get journal list from backend then update journalList in vuex store ***** //
export const updateJournalList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc',
      start_date: payload.start_date,
      end_date: payload.end_date
    }
  }

  try {
    const result = await Axios.get(`report_general_journal`, {
      params: params
    })
    commit('updateJournalList', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}
